export default __webpack_public_path__ + "static/media/pyqt.87b4c797.png";